import { render, staticRenderFns } from "./EmailViewer.vue?vue&type=template&id=84ec904e&scoped=true&"
import script from "./EmailViewer.vue?vue&type=script&lang=js&"
export * from "./EmailViewer.vue?vue&type=script&lang=js&"
import style0 from "./EmailViewer.vue?vue&type=style&index=0&id=84ec904e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ec904e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
